import getDefaultHeader from 'lowcode/utils/service/getDefaultHeader';
import { getHostApi } from 'lowcode/utils/service/getHostApi';
import { useEffect, useRef } from 'react';
import { useDP3Dispatch, useDP3Store } from '../../DP3Provider';
import { IPageStatus } from '../IPageStatus';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { useRouter } from 'next/router';

const CountDown = () => {
    const dispatch = useDP3Dispatch();
    const { pageStatus, timeLine } = useDP3Store();
    const { getSystemTime } = useGlobal();
    const { locale } = getLocal();
    const timer = useRef<NodeJS.Timeout | null>(null);
    const serverTime = useRef(getSystemTime());
    const clientTime = useRef(new Date().getTime());
    const { query } = useRouter();

    const handleVisibleChange = () => {
        if (window.document.visibilityState === 'visible') {
            getServiceTime();
        }
    };

    const getServiceTime = async () => {
        const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
        const headers: any = getDefaultHeader(locale);

        try {
            const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                headers,
            });

            const { data } = await spuData.json();
            serverTime.current = data?.timestamp;
        } catch (e) {
            console.log(e);
            serverTime.current = getSystemTime();
        }
    };

    const handleTimeOut = async () => {
        let nowTime = 0;
        if (query?._timer) {
            nowTime = new Date(query?._timer + ' GMT+8').getTime();
            serverTime.current = nowTime;
        } else {
            nowTime = new Date().getTime();
            const intervalTime = nowTime - clientTime.current;
            // 倒计时执行间隔超过2s
            if (intervalTime > 2000 && !query?._timer) {
                await getServiceTime();
            } else {
                serverTime.current += intervalTime;
            }
        }
        // 当前阶段
        let status = IPageStatus.statusA;
        if (timeLine) {
            if (serverTime.current >= timeLine.statusD?.start) {
                status = IPageStatus.statusD;
            } else if (serverTime.current >= timeLine.statusC?.start) {
                status = IPageStatus.statusC;
            } else if (serverTime.current >= timeLine.statusB?.start) {
                status = IPageStatus.statusB;
            } else if (serverTime.current >= timeLine.statusA?.start) {
                status = IPageStatus.statusA;
            }
        }
        if (status !== pageStatus) {
            dispatch({
                type: 'changePageStatus',
                payload: status,
            });
        }
        clientTime.current = nowTime;
        timer.current = setTimeout(handleTimeOut, 1000);
    };

    useEffect(() => {
        // 倒计时部分
        timer.current = setTimeout(handleTimeOut, 1000);
        // visiblity部分
        window.document.addEventListener('visibilitychange', handleVisibleChange);
        return () => {
            timer.current && clearTimeout(timer.current);
            window.document.removeEventListener('visibilitychange', handleVisibleChange);
        };
    }, []);

    useEffect(() => {
        timer.current && clearTimeout(timer.current);
        timer.current = setTimeout(handleTimeOut, 1000);
    }, [pageStatus]);

    return <div></div>;
};

export default CountDown;
